import React, { useState, useEffect } from 'react';
import { getFeaturedProjects, getProjects } from '../../api/services';
import './RecentProjects.css';

function RecentProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getFeaturedProjects()
      .then(res => {
        if (res.success && res.data.length > 0) {
          setProjects(res.data.slice(0, 6));
        } else {
          // Fallback: no featured projects set, just show most recent ones
          return getProjects().then(r => {
            if (r.success) setProjects(r.data.slice(0, 6));
          });
        }
      })
      .catch(err => console.error('Failed to load recent projects:', err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null; // or a skeleton/loader if you prefer

  if (projects.length === 0) return null; // nothing to show

  return (
    <section id="projects" className="section projects-section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Our Work</span>
          <h2 className="section-title">Recent Projects</h2>
          <p className="section-subtitle">Showcasing our craftsmanship and attention to detail</p>
        </div>
        <div className="projects-grid">
          {projects.map((project) => (
            <div key={project.id} className="project-card">
              <div className="project-image">
                <img
                  src={project.cover_image || '/images/placeholder.jpg'}
                  alt={project.title}
                />
                <div className="project-overlay">
                  <span className="project-category">{project.category}</span>
                  <h3 className="project-title-overlay">{project.title}</h3>
                  <a href={`/projects/${project.slug}`} className="project-view-btn">
                    View Details
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default RecentProjects;